<template>

  <div>
<!--      <productlistjumbotron></productlistjumbotron>
       <div class="container">
         <configurationhead></configurationhead>
      </div>-->
      <div class="container mb-5">
        <productlisttable ref="prodlisttable"></productlisttable>
      </div>
  </div>
</template>

<script>
    import productlistjumbotron  from './ProductListJumbotron'
    import productlisttable  from './ProductListTable'
    import { EventBus } from './services/eventbus/event-bus'
    import configurationhead from './ConfigurationHead'

    export default {
        props:['search_flag'],
        components: {
              productlistjumbotron,
              productlisttable,
              configurationhead
        },

        data() {
          return {
          }
		    },
        methods: {

        },
        mounted () {
          //https://jefrydco.id/en/blog/safe-access-vue-refs-undefined/
          EventBus.$on('loadprodlist', () => {
                  console.log('EventBus this.$refs');
                  console.log(this);

                  const interval = setInterval(() => {
                    if (this.$refs.prodlisttable!==undefined) {
                      console.log('interval:')
                      console.log(interval)

                      console.log(this.$refs.prodlisttable)
                      // VueComponent{}
                      console.log(this.$refs)
                      // {prodlisttable: VueComponent}
                      this.$refs.prodlisttable.getFans()
                      clearInterval(interval)
                    }
                  }, 50)
          })
        },
        created(){

         /*  EventBus.$on('loadprodlist', () => {
                  console.log('EventBus this.$refs');
                  console.log(this);
                  this.$refs.prodlisttable.getFans()
          })// from ProductSearch  */
        }


    }
</script>
